import * as React from "react";
const SvgFiRrAngleDoubleSmallUp = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M6 18a1 1 0 0 1-.705-1.71l6.001-5.964a1 1 0 0 1 1.41 0l6 5.964a.999.999 0 1 1-1.41 1.418L12 12.445l-5.296 5.264A1 1 0 0 1 6 18m12.712-6.56a1 1 0 0 0-.01-1.414l-3.925-3.875A3.9 3.9 0 0 0 12 5a3.9 3.9 0 0 0-2.772 1.146l-3.93 3.88a1 1 0 1 0 1.404 1.423l3.935-3.884c.73-.729 1.993-.733 2.731.004l3.93 3.88a.996.996 0 0 0 1.414-.008z"
    />
  </svg>
);
export default SvgFiRrAngleDoubleSmallUp;
